// @ts-nocheck
const TranslatorTasksSkeleton = () => {

    return (
        <div>Es lädt...</div>
    )
}

export default TranslatorTasksSkeleton